var render = function render(_c,_vm){return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 48 48","aria-hidden":"true","fill":"currentColor"}},[_c('path',{attrs:{"d":"m47.626 24.545-5.912 6.992a.664.664 0 0 1-1.173-.426.654.654 0 0 1 .156-.426l4.965-5.873H.646a.664.664 0 1 1 0-1.327H45.74l-5.05-6.176a.665.665 0 0 1 1.031-.839l6.261 7.656Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }